export default __webpack_public_path__ + "static/media/PlayerInfoBackground.03894c5f.png";